<template>
  <header>
    <a @click="changeContentsName('Main')" class="logo">
      <img src="img/logo.png" alt="지미추로고">
    </a>

    <img src="img/txt_join.png" alt="사용자영역" class="join">
  </header>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {
    name: 'Header',
    data () {
      return {

      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue